
<template>
  <div class="XVdropdownsearch" v-if="datalist">
    <div :class="inputgroupclass">
      <input
        class="dropdown-input form-control"
        @focus="showOptions()"
        @blur="exit()"
        @keyup.enter.prevent="keyMonitor"
        :value="searchFilter"
        :placeholder="translation(placeholder)"
        @input="searchFilter = $event.target.value"
        :disabled="disabled"
      />
      <span class="input-group-btn" v-if="!required && !this.disabled">
        <button
          class="btn btn-primary resetxvdropdownsearch"
          @click="resetxvdropdownsearch()"
          type="button"
        >
          <font-awesome-icon class="fa-lg" icon="times" />
        </button>
      </span>
    </div>
    <!-- Dropdown Menu -->
    <div class="dropdown-content" v-show="optionsShown === true">
      <div
        class="dropdown-item"
        v-for="(option, index) in filteredOptions"
        :key="index"
        @mousedown="selectOption(option)"
      >
        <div>{{ option.labelText || option.value || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
export default {
  name: 'XVdropdownsearch',
  inheritAttrs: false,
  mixins: [FAMixin],
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    datalist: {
      type: Array,
      required: true
    },
    value: {
      default: ''
    },
    placeholder: {
      type: Number,
      required: false,
      default: 15366,
      // 15366 = selecteer een optie
      note: 'Placeholder of dropdown'
    },
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      selected: {},
      optionsShown: false,
      searchFilter: '',
      lastselected: {}
    }
  },
  mounted() {
    if (this.value) {
      this.searchFilter = this.value.labelText
      this.lastselected = this.value
    }
  },
  created() {
    this.$emit('selected', this.selected)
  },
  computed: {
    filteredOptions() {
      if (this.searchFilter !== undefined) {
        const filtered = []
        for (const option of this.datalist) {
          if (
            this.searchFilter.length < 1 ||
            option.labelText.toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1
          ) {
            filtered.push(option)
          }
        }
        return filtered
      } else {
        return []
      }
    },
    inputgroupclass() {
      if (this.required === false && this.disabled === false) {
        return 'input-group'
      } else {
        return ''
      }
    }
  },
  methods: {
    selectOption(option) {
      this.selected = option
      this.optionsShown = false
      this.searchFilter = this.selected.labelText
      this.lastselected = this.selected
      this.events()
    },
    showOptions() {
      if (!this.disabled) {
        this.searchFilter = ''
        this.optionsShown = true
      }
    },
    exit() {
      if (!this.selected.value) {
        this.selected = {}
        this.searchFilter = ''
      } else {
        this.selected = this.lastselected
        this.searchFilter = this.lastselected.labelText
      }
      this.optionsShown = false
      this.events()
    },
    // Selecting when pressing Enter
    keyMonitor() {
      if (this.filteredOptions[0]) {
        this.selectOption(this.filteredOptions[0])
      }
    },
    events() {
      if (this.selected.value !== undefined) {
        let dliobj = this.datalist.filter(v => {
          return String(v.value) === String(this.selected.value)
        })[0]
        this.$emit('input', this.selected.value)
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: dliobj.value,
          labelText: dliobj.labelText,
          id: this.id,
          formdata: this.formdata,
          selected: this.selected
        })
      } else {
        this.$emit('input', '')
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: '',
          labelText: '',
          id: this.id,
          formdata: this.formdata,
          selected: this.selected
        })
      }
    },
    resetxvdropdownsearch() {
      this.selected = {}
      this.searchFilter = ''
      this.lastselected = {}
      this.events()
    }
  },
  watch: {
    searchFilter() {
      if (this.filteredOptions) {
        if (this.filteredOptions.length === 0) {
          this.selected = {}
        } else {
          this.selected = this.filteredOptions[0]
        }
        this.$emit('filter', this.searchFilter)
      }
    }
  }
}
</script>


<style scoped>
.XVdropdownsearch {
  box-sizing: content-box;
  display: block;
  position: relative;
}
.dropdown {
  position: relative;
  display: block;
  margin: auto;
}
.dropdown:hover {
  background: #f8f8fa;
}
.dropdown-input {
  cursor: pointer;
  /* BS4CUSTOM width uitgezet */
  /* width: 100%; */
}
.dropdown-content {
  position: absolute;
  display: block;
  background-color: #fff;
  width: 100%;
  max-height: 248px;
  border: 1px solid #e7ecf5;
  box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
  overflow: auto;
  z-index: 999;
}
.dropdown-item {
  color: black;
  line-height: 1em;
  padding: 8px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}
.dropdown-item:hover {
  background-color: #e7ecf5;
}

.dropdown-content {
  display: block;
}
</style>
